// API-3864's unit alerts, shaped for display. The API returns [{ type, subtype, severity, title, detail, asOf, source, url, layerIds }]
// already in display order (warnings first, then fire, closure, news, drought, weather, burn, forum; news that names the
// unit before other news), so the groups keep it. Types: fire, burn, closure, drought, snow, precip, heat, cold, news, forum.

const LABELS = {
  fire: 'Fire', burn: 'Burn', closure: 'Closure', drought: 'Drought', snow: 'Snow', precip: 'Rain & snow',
  heat: 'Heat', cold: 'Cold', news: 'News', forum: 'Forum',
}

export const alertLabel = (type) => LABELS[type] || 'Alert'

const list = (alerts) => (Array.isArray(alerts) ? alerts : Array.isArray(alerts?.alerts) ? alerts.alerts : [])
  .filter((a) => a && a.title)

// { conditions: fires, closures, drought and weather; news; forum }, each in the API's order.
export const groupAlerts = (alerts) => {
  const all = list(alerts)
  return {
    conditions: all.filter((a) => a.type !== 'news' && a.type !== 'forum'),
    news: all.filter((a) => a.type === 'news'),
    forum: all.filter((a) => a.type === 'forum'),
  }
}

// The BaseMap layers that show an alert on the map (fire, burn and drought carry them), as numbers; [] for none.
export const alertLayerIds = (alert) => (Array.isArray(alert?.layerIds) ? alert.layerIds : [])
  .map(Number).filter((id) => Number.isInteger(id) && id > 0)

// The layers the user has on (the layer menu's setting 1), as numbers.
export const activeLayerIds = (state) => {
  const setting = (state?.userSettings || []).find((s) => s.settingId === 1)
  return (setting?.valueArray || []).map(Number)
}

// Whether all of an alert's layers are on, so its button turns them off.
export const layersOn = (layerIds, active) => layerIds.length > 0 && layerIds.every((id) => (active || []).includes(id))

// Warnings only, for hunt details: conditions, then news.
export const warningAlerts = (alerts) => {
  const { conditions, news } = groupAlerts(alerts)
  return [...conditions, ...news].filter((a) => a.severity === 'warning')
}

// "Oct 27" (or "Oct 27, 2025" outside this year) from an ISO date or date-time (fires carry the time); '' when missing.
export const asOfText = (asOf, now = new Date()) => {
  if (!asOf) return ''
  const d = new Date(asOf)
  if (isNaN(d)) return ''
  const sameYear = d.getUTCFullYear() === now.getUTCFullYear()
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', ...(sameYear ? {} : { year: 'numeric' }), timeZone: 'UTC' })
}
